import Vue from 'vue'
import VueI18n from 'vue-i18n'

import {detectLocale} from './locale'

Vue.use(VueI18n)

export default new VueI18n({
  locale: detectLocale(),
  messages: {
    da: {
      about: require('./about').default.da,
      blog: require('./blog').default.da,
      city: require('./city').default.da,
      clients: require('./clients').default.da,
      facts: require('./facts').default.da,
      footer: require('./footer').default.da,
      passion: require('./passion').default.da,
      positions: require('./positions').default.da,
      ready: require('./ready').default.da,
      team: require('./team').default.da,
    },
    en: {
      about: require('./about').default.en,
      blog: require('./blog').default.en,
      city: require('./city').default.en,
      clients: require('./clients').default.en,
      facts: require('./facts').default.en,
      footer: require('./footer').default.en,
      passion: require('./passion').default.en,
      positions: require('./positions').default.en,
      ready: require('./ready').default.en,
      team: require('./team').default.en,
    }
  }
})




// WEBPACK FOOTER //
// ./src/multilanguage/index.js